import script from "./UserType.vue?vue&type=script&setup=true&lang=js"
export * from "./UserType.vue?vue&type=script&setup=true&lang=js"

import "./UserType.vue?vue&type=style&index=0&id=285429c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285429c2"]])

export default __exports__